module.exports = "//public.getcloudapp.com/packs/media/images/cloud-loader-a88256752831665ed2d12141761bee79.gif";